import React from 'react';

import type { InstagramPostComponentsProps } from './types';

export function Body(_props: InstagramPostComponentsProps): React.JSX.Element {
	return <div>Instagram Post Body</div>;
}
